import getNameInitials from '../../../utils/strings/getNameInitials'
import type { Contributor, Creator } from '../../../../../server/typings'
import type { ActivityInformation, Edge } from '../../../../../typings'

export type PersonInfo = {
  name?: {
    fullName?: string
  }
  profilePhotoUrl?: string
}

export type ActivityItemParam = {
  person: Contributor | Creator
  personInitials: string
  profilePhotoUrl: string
  amount: string
  description: string
  time: string
  typename: string
  transactionId: string
}

const getProfilePhoto = (person: Contributor | Creator) => {
  /* this appears to be needed so that TypeScript can infer the types correctly
   *  if you use person.displayPhotoUrl || person.profilePhotoUrl, typescript complains */
  if ('displayPhotoUrl' in person) {
    return person.displayPhotoUrl
  }

  return person.profilePhotoUrl
}

export const getActivityItems = (
  activities: Edge<ActivityInformation>[],
): ActivityItemParam[] => {
  return activities?.map((item) => {
    const person = item.node?.contributor || item.node?.withdrawer
    const personInitials = getNameInitials(
      person.name?.givenName,
      person.name?.surname,
    )
    return {
      person,
      personInitials,
      profilePhotoUrl: getProfilePhoto(person),
      amount: item.node?.formattedAmount,
      description: item.node?.description,
      time:
        item.node?.formattedContributionTime ||
        item.node?.formattedWithdrawalTime,
      typename: item.node?.__typename,
      transactionId: item.node?.encryptedTransactionId,
    }
  })
}
